import { PROJECT_DEFAULT } from "../../constants/general";

//CONSTANTES
const GET_SESSIONS = "GET_SESSIONS";
const GET_SESSIONS_SUCCESS = "GET_SESSIONS_SUCCESS";
const GET_SESSIONS_FAIL = "GET_SESSIONS_FAIL";

/**
 * State of Action.
 * @typedef {Object} Action
 * @property {string} type - Type of Action.
 * @property {any} payload - Paylod from action.
 */
/**
 * State of Session.
 * @typedef {Object} Session
 * @property {string} server
 * @property {string} session
 */
/**
 * State of Session.
 * @typedef {Object} SessionData
 * @property {string} projectName - Project Name.
 * @property {Array.<Session>} sessions - Array of sessions and servers.
 */

/**
 * State of Session.
 * @typedef {Object} StateSession
 * @property {Array.<SessionData>} data - Data from back.
 * @property {boolean} loading - Its loading.
 * @property {boolean} hasError - Indicates error status.
 * @property {string} messageError - Indicates error Message.
 */
const initialState = {
  data: [],
  loading: false,
  hasError: false,
  messageError: "",
  lastLoadSession: false,
};

/**
 *
 * @param {StateSession} state state.
 * @param {Action} [action] action
 */
export default function session(state = initialState, action) {
  switch (action.type) {
    case GET_SESSIONS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SESSIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload.data],
        lastLoadSession: new Date(),
      };
    }

    case GET_SESSIONS_FAIL: {
      let details = action?.error?.response?.data?.error;

      return {
        ...state,
        loading: false,
        hasError: true,
        messageError: details,
      };
    }
    default:
      return state;
  }
}

/**
 * Get Session of McrStrategy
 * @param {string} project ProjectName
 */
export function getSession(project = PROJECT_DEFAULT) {
  return {
    type: GET_SESSIONS,
    payload: {
      request: {
        url: `Auth/MSSession/${project}`,
      },
    },
  };
}

/**
 * Get Session For DevMcrStrategy
 * @param {string} project ProjectName
 */
export function getSessionTesting(project) {
  return {
    type: GET_SESSIONS,
    payload: {
      request: {
        url: `Auth/MSTestingSession/${project}`,
      },
    },
  };
}
